import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { CurriculumStudentsWrapper } from "./routes";

export default store => {
  const curriculumStudentsWrapperRoute = CurriculumStudentsWrapper(store);
  return {
    path: "generate-transcripts",
    component: withAsyncRouteLoading(() =>
      import(
        /* webpackChunkName: "transcripts-generate-transcripts" */ "./components"
      ).then(m => m.default)
    ),
    childRoutes: [
      {
        ...curriculumStudentsWrapperRoute,
        path: ":curriculumProgramId",
      },
      curriculumStudentsWrapperRoute,
    ],
  };
};
